import { LicenseDevice } from './license-device.model';

export class License {

    private internalId: string;
    private description: string;
    private quantity: number;
    private inUse: number;
    private startDate: number;
    private endDate: number;
    private multiCenter: boolean;
    private multiApp: boolean;
    private centerName: string;
    private appName: string;
    private deviceList: LicenseDevice[];

    constructor(internalId?: string,
                description?: string,
                quantity?: number,
                inUse?: number,
                startDate?: number,
                endDate?: number,
                multiCenter?: boolean,
                multiApp?: boolean,
                centerName?: string,
                appName?: string,
                deviceList?: LicenseDevice[]) {
                    this.internalId =  internalId;
                    this.description =  description;
                    this.quantity =  quantity;
                    this.inUse =  inUse;
                    this.startDate =  startDate;
                    this.endDate =  endDate;
                    this.multiCenter =  multiCenter;
                    this.multiApp =  multiApp;
                    this.centerName =  centerName;
                    this.appName =  appName;
                    this.deviceList =  deviceList;
        }


    public get InternalId(): string {
        return this.internalId;
    }
    public get Description(): string {
        return this.description;
    }
    public get Quantity(): number {
        return this.quantity;
    }
    public get InUse(): number {
        return this.inUse;
    }
    public get StartDate(): number {
        return this.startDate;
    }
    public get EndDate(): number {
        return this.endDate;
    }
    public get MultiCenter(): boolean {
        return this.multiCenter;
    }
    public get MultiApp(): boolean {
        return this.multiApp;
    }
    public get CenterName(): string {
        return this.centerName;
    }
    public get AppName(): string {
        return this.appName;
    }
    public get DeviceList(): LicenseDevice[] {
        return this.deviceList;
    }



    public set InternalId(internalId: string) {
        this.internalId = internalId;
    }
    public set Description(description: string) {
        this.description = description;
    }
    public set Quantity(quantity: number) {
        this.quantity = quantity;
    }
    public set InUse(inUse: number) {
        this.inUse = inUse;
    }
    public set StartDate(startDate: number) {
        this.startDate = startDate;
    }
    public set EndDate(endDate: number) {
        this.endDate = endDate;
    }
    public set MultiCenter(multiCenter: boolean) {
        this.multiCenter = multiCenter;
    }
    public set MultiApp(multiApp: boolean) {
        this.multiApp = multiApp;
    }
    public set CenterName(centerName: string) {
        this.centerName = centerName;
    }
    public set AppName(appName: string) {
        this.appName = appName;
    }
    public set DeviceList(deviceList: LicenseDevice[]) {
        this.deviceList = deviceList;
    }

}
